import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export default class SettingsNotificationsRoute extends Route {
	@service('model-manager/notifications')
	declare mmNotificationsService: Service.ModelManager.Notifications;

	override async beforeModel() {
		await this.mmNotificationsService.requestAllTargetsForNotifications();
		await this.mmNotificationsService.requestConnectedModelsForNotifications();
	}
}
